module.exports = __webpack_public_path__ + "img/btn-join.e1d5c010.png";